import React, { useEffect, useState, useContext } from 'react';
import { useParams } from "react-router-dom";
import Header from '../Header/AppHeader';
import Axiosfetch from '../Common/Axiosfetch';
import 'bootstrap/dist/css/bootstrap.min.css';
import html2canvas from 'html2canvas';
import jsPdf from 'jspdf'
import Alert from 'react-s-alert';
import moment from 'moment';
import '../GenerateQuotation/GenerateQuoteStyle.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDownload, faFilePdf, faEnvelope } from '@fortawesome/free-solid-svg-icons';
import baseURL from '../Common/Config';
import numberToEnglish from '../Common/CommonMethods';
import FailureAlert from '../Common/Failure';
import Barcode from 'react-barcode';
//import FormatEmail from '../Common/EmailService';
import WaterMark from '../../Images/watermark_mfi.png';
import Base64 from 'base-64';
import * as htmlToImage from 'html-to-image';
import Select from 'react-select';

const GenerateInvoice = () => {
    var { InvID } = useParams();
    const [companyInfo, setCompanyInfo] = useState([]);
    const [InvoicesInfo, setInvoicesInfo] = useState([]);
    const [InvoicesData, setInvoicesData] = useState([]);
    const [GoodsData, setGoodsData] = useState([]);
    const [ProductsPDFInfo, setProductsPDFInfo] = useState({});
    const [TotalAmountAndCustomerPDFInfo, setTotalAmountAndCustomerPDFInfo] = useState([]);
    const [SelectedInvoiceDropDownInfo, setSelectedInvoiceDropDownInfo] = useState({ label: null, value: null });
    const [SelectedInvoicePDFInfo, setSelectedInvoicePDFInfo] = useState(0);
    //const [SelectedInvoice, setSelectedInvoice] = useState(0);
    // const [EmailSettings, setEmailSettings] = useState({});
    const [companyLogo, setcompanyLogo] = useState("");
    const [IBALogo, setIBALogo] = useState("");
    const [WithBreakup, setWithBreakup] = useState(true);
    const [Insurance, setInsurance] = useState(true);
    const [IBAData, setIBAData] = useState({});
    const [PaymentCode, setPaymentCode] = useState(null);
    //const [InvoiceNumber, setInvoiceNumber] = useState("");

    const OrgData = localStorage.getItem("userData") ? JSON.parse(localStorage.getItem("userData")) : null;

    useEffect(() => {
        FetchInitialData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const FetchInitialData = () => {
        var CompanyLogo = localStorage.getItem("CompanyLogo") ? localStorage.getItem("CompanyLogo") : null;
        if (OrgData && localStorage.getItem("CompanyInfo") !== null) {
            var companyDetails = JSON.parse(localStorage.getItem("CompanyInfo"));
            setCompanyInfo(companyDetails);

            if (CompanyLogo !== null) {
                setcompanyLogo(CompanyLogo);
            }
            else {
                setcompanyLogo("");
            }

            Axiosfetch(baseURL + "GetActiveInvoicesByOrgID", "POST", { OrgID: OrgData.OrganizationID }, getInvoicesSuccess, Failure);
        }
        else {
            if (localStorage.getItem("CompanyInfo") !== null) {
                Alert.error("Error occured While Loading Invoice. Please login to the application again before attempting the steps.", {
                    position: 'bottom-right',
                    effect: 'slide',
                    html: false
                });
            }
            else {
                Alert.error("Please update Company Info to proceed with Quotation.", {
                    position: 'bottom-right',
                    effect: 'slide',
                    html: false
                });
            }
        }
    };

    const getInvoicesSuccess = (data) => {
        if (data.length > 0) {
            var invoices = [];
            setInvoicesData(data);
            data.forEach(value => {

                let invoiceNumber = "#" + value.InvoiceID + "_" + moment(value.createdAt).local().format("DDMMYYYY");
                invoices.push({ value: value.InvoiceID, label: invoiceNumber });
            });

            if (InvID !== undefined) {
                var inv = invoices.filter(q => q.value === parseFloat(InvID));
                if (inv !== null && inv.length > 0) {
                    setSelectedInvoiceDropDownInfo(inv[0]);
                    GetInvoiceData(inv[0], data);
                }
            }

            setInvoicesInfo(invoices);
            FetchOrgPaymentLogo();
            //FetchEmailSettings();
        }
        else {
            setInvoicesData([]);
            setInvoicesInfo([]);
        }
    };

    // const FetchEmailSettings = () => {
    //     Axiosfetch(baseURL + "GetEmailSettings", "GET", null, getEmailSettingsSuccess, Failure);
    // };

    // const getEmailSettingsSuccess = (data) => {
    //     if (data.length > 0) {
    //         setEmailSettings(data[0]);
    //     }
    //     else {
    //         setEmailSettings({});
    //     }
    // };

    const FetchOrgPaymentLogo = () => {
        let OrgPaymentCode = (OrgData.Organization && OrgData.Organization.length > 0) ? OrgData.Organization[0].PaymentLogo : null;
        if (OrgPaymentCode) {
            Axiosfetch(baseURL + "GetPaymentLogo", "POST", { fileName: OrgPaymentCode }, paymentCodeSuccess, Failure);
        }
    };

    const paymentCodeSuccess = (data) => {
        if (data.success) {
            setPaymentCode(data.fileData)
        }
        else {
            setPaymentCode(null);
        }
    };

    const setInvoiceIDCriteria = (Invoice) => {
        GetInvoiceData(Invoice, null);
    };

    const GetInvoiceData = (Invoice, invoiceList) => {
        if (Invoice !== null) {
            let InvoiceID = Invoice.value;
            setSelectedInvoicePDFInfo(InvoiceID);
            var InvoiceToGenerate = [];
            if (invoiceList !== null) {
                InvoiceToGenerate = invoiceList.filter(q => q.InvoiceID === InvoiceID);
            }
            else {
                setSelectedInvoiceDropDownInfo(Invoice);
                InvoiceToGenerate = InvoicesData.filter(q => q.InvoiceID === InvoiceID);
            }

            if (InvoiceToGenerate.length > 0) {
                setTotalAmountAndCustomerPDFInfo(InvoiceToGenerate[0]);
                let QuotationID = InvoiceToGenerate[0].Quotation.length > 0 ? InvoiceToGenerate[0].Quotation[0].QuoteID : 0;
                var userData = localStorage.getItem("userData") ? JSON.parse(localStorage.getItem("userData")) : null;
                Axiosfetch(baseURL + "GetQuotationsByQuoteAndOrgID", "POST", { QuoteID: QuotationID, OrgID: userData.OrganizationID }, ProductDataSuccess, Failure);
            }
        }
        else {
            setSelectedInvoicePDFInfo(0);
            setTotalAmountAndCustomerPDFInfo([]);
            setSelectedInvoiceDropDownInfo({ value: null, label: null });
        }
    }

    const ProductDataSuccess = (data) => {
        if (data.length > 0) {
            if (data[0].Goods.length > 0) {
                setGoodsData(data[0].Goods);
            }
            else {
                setGoodsData([]);
            }

            setProductsPDFInfo(data[0]);

            // if (data[0].Partner && data[0].Partner.length > 0) {
            //     ComputeInvoiceNumber(data);
            // }

            if (data[0].Customer && data[0].Customer.length > 0 && data[0].Customer[0].IBAApproval === 1) {
                Axiosfetch(baseURL + "GetActiveIBAData", "GET", null, IBADataSuccess, Failure);
            }
        }
        else {
            setProductsPDFInfo({});
        }
    };

    // const ComputeInvoiceNumber = (InvoiceData) => {
    //     let partnerDetails = InvoiceData[0].Partner[0];
    //     let Name = partnerDetails.Name.split(' ').map(c => c[0]).join('');
    //     let invoiceNumber = `${Name}-${TotalAmountAndCustomerPDFInfo.InvoiceID.toString().padStart(4, '0')}_${moment(TotalAmountAndCustomerPDFInfo.createdAt).local().format("DDMMYYYY")}`;

    //     setInvoiceNumber(invoiceNumber);
    // }

    const IBADataSuccess = (data) => {
        if (data.length > 0) {
            setIBAData(data[0]);
            Axiosfetch(baseURL + "GetIBAFile", "POST", { fileName: data[0].IBAFileName }, IBAFileDataSuccess, Failure);
        }
    };

    const IBAFileDataSuccess = (data) => {
        if (data.success) {
            if (data.fileData !== null) {
                setIBALogo(data.fileData);
            }
            else {
                Alert.error("Error fetching IBA Logo", {
                    position: 'bottom-right',
                    effect: 'slide',
                    html: false
                });
            }
        }
        else {
            Alert.error("Error fetching IBA Logo", {
                position: 'bottom-right',
                effect: 'slide',
                html: false
            });
        }
    };

    const printPDF = () => {
        if (SelectedInvoicePDFInfo > 0) {
            const domElement = document.getElementById('page');
            html2canvas(domElement, {
                scale: 1.6
            })
                .then((canvas) => {
                    const imgData = canvas.toDataURL('image/png');
                    var imgWidth = 205;
                    var pageHeight = 295;
                    var imgHeight = canvas.height * imgWidth / canvas.width;
                    var heightLeft = imgHeight;
                    var doc = new jsPdf('p', 'mm');
                    var position = 2;

                    doc.addImage(imgData, 'PNG', 2, position, imgWidth, imgHeight, '', 'FAST');
                    heightLeft -= pageHeight;

                    while (heightLeft >= 0) {
                        position = heightLeft - imgHeight;
                        doc.addPage();

                        doc.addImage(imgData, 'PNG', 2, position + 1, imgWidth, imgHeight, '', 'FAST');
                        heightLeft -= pageHeight;

                    }

                    doc.save('Invoice_' + TotalAmountAndCustomerPDFInfo.InvoiceID + "_" +
                        moment(TotalAmountAndCustomerPDFInfo.createAt).local().format("DDMMYYYY") + '.pdf');
                });
        }
        else {
            Alert.error("Please Select Invoice.", {
                position: 'bottom-right',
                effect: 'slide',
                html: false
            });
        }
    };

    const SendEmail = () => {
        if (SelectedInvoicePDFInfo > 0) {
            const domElement = document.getElementById('page');
            html2canvas(domElement, {
                scale: 1.6
            })
                .then((canvas) => {
                    const imgData = canvas.toDataURL('image/png');
                    var imgWidth = 205;
                    var pageHeight = 295;
                    var imgHeight = canvas.height * imgWidth / canvas.width;
                    var heightLeft = imgHeight;
                    var doc = new jsPdf('p', 'mm');
                    var position = 2;

                    doc.addImage(imgData, 'PNG', 2, position, imgWidth, imgHeight, '', 'FAST');
                    heightLeft -= pageHeight;

                    while (heightLeft >= 0) {
                        position = heightLeft - imgHeight;
                        doc.addPage();

                        doc.addImage(imgData, 'PNG', 2, position + 1, imgWidth, imgHeight, '', 'FAST');
                        heightLeft -= pageHeight;

                    }

                    var out = doc.output();
                    var attachment = 'data:application/pdf;base64,' + Base64.encode(out);
                    let customEmail = TotalAmountAndCustomerPDFInfo.Quotation.Customer ? TotalAmountAndCustomerPDFInfo.Quotation.Customer.EmailID : null;
                    if (customEmail !== null || customEmail !== undefined) {
                        var InvoiceDetails = InvoicesData.filter(q => q.InvoiceID === parseInt(SelectedInvoiceDropDownInfo.value));
                        if (InvoiceDetails.length > 0) {

                            var invoiceNumber = TotalAmountAndCustomerPDFInfo.InvoiceID + "_" + moment(TotalAmountAndCustomerPDFInfo.createdAt).local().format("DDMMYYYY");;
                            if (invoiceNumber !== "") {
                                var TotalAmount = parseFloat(TotalAmountAndCustomerPDFInfo.Quotation[0].TotalAmount) +
                                    (TotalAmountAndCustomerPDFInfo.InterState === 0 ?
                                        (((parseFloat(TotalAmountAndCustomerPDFInfo.Quotation[0].TotalAmount) * (TotalAmountAndCustomerPDFInfo.SGST / 100))) +
                                            (parseFloat(TotalAmountAndCustomerPDFInfo.Quotation[0].TotalAmount) * (TotalAmountAndCustomerPDFInfo.CGST / 100)))
                                        : (parseFloat(TotalAmountAndCustomerPDFInfo.Quotation[0].TotalAmount) * (TotalAmountAndCustomerPDFInfo.IGST / 100)));

                                var userData = localStorage.getItem("userData") ? localStorage.getItem("userData") : null;
                                var parsedUserData = JSON.parse(userData);

                                let FormattedEmail = {};
                                FormattedEmail.To = "pankajgandhi1010@gmail.com"; //(ProductsPDFInfo?.Customer && ProductsPDFInfo?.Customer.length > 0) ? ProductsPDFInfo?.Customer[0].EmailID : "";
                                FormattedEmail.From = "pankajgandhi1010@gmail.com"; //parsedUserData.Email[0].From;
                                FormattedEmail.ToAddress = ProductsPDFInfo.Customer && ProductsPDFInfo.Customer.length > 0 ?
                                    ProductsPDFInfo.Customer[0].OriginAddress + " , " + ProductsPDFInfo.Customer[0].OriginCity + " " +
                                    ProductsPDFInfo.Customer[0].OriginPincode + " , " + ProductsPDFInfo.Customer[0].OriginState + " , " +
                                    ProductsPDFInfo.Customer[0].OriginCountry : "";
                                FormattedEmail.FromAddress = ProductsPDFInfo.Customer && ProductsPDFInfo.Customer.length > 0 ?
                                    ProductsPDFInfo.Customer[0].DestinationAddress + " , " + ProductsPDFInfo.Customer[0].DestinationCity + " " +
                                    ProductsPDFInfo.Customer[0].DestinationPincode + " , " + ProductsPDFInfo.Customer[0].DestinationState + " , " +
                                    ProductsPDFInfo.Customer[0].DestinationCountry : "";
                                FormattedEmail.Subject = "Invoice";
                                FormattedEmail.Amount = TotalAmount;
                                FormattedEmail.FileName = "test.png"; //parsedUserData.Email[0].FileName;
                                FormattedEmail.Subject = "Invoice";
                                FormattedEmail.CustomerName = (ProductsPDFInfo?.Customer && ProductsPDFInfo.Customer.length > 0) ? ProductsPDFInfo.Customer[0].Name : "";
                                FormattedEmail.OrgName = parsedUserData.Organization && parsedUserData.Organization.length > 0 ? parsedUserData.Organization[0].Name : "";
                                FormattedEmail.OrgAddress = companyInfo.BillingAddress;
                                FormattedEmail.OrgContact = `${companyInfo.Contact} ${companyInfo.AlternateContact !== 0 ? " / " + companyInfo.AlternateContact : ""}`;
                                FormattedEmail.ID = invoiceNumber;
                                FormattedEmail.Date = moment(TotalAmountAndCustomerPDFInfo.createdAt).local().format("DDMMYYYY").toString();
                                FormattedEmail.Attachment = attachment;

                                Axiosfetch(baseURL + "SendEmail", "POST", FormattedEmail, emailDataEditSuccess, Failure);
                            }
                            else {
                                Alert.success("Error getting Invoice Number. Please try again.", {
                                    position: 'bottom-right',
                                    effect: 'slide',
                                    html: false
                                });
                            }
                        }
                        else {
                            Alert.success("Error getting Invoice Details. Please try again.", {
                                position: 'bottom-right',
                                effect: 'slide',
                                html: false
                            });
                        }
                    }
                    else {
                        Alert.success("Please add customer Email ID to send Email", {
                            position: 'bottom-right',
                            effect: 'slide',
                            html: false
                        });
                    }
                });
        }
        else {
            Alert.error("Please Select Invoice.", {
                position: 'bottom-right',
                effect: 'slide',
                html: false
            });
        }
    };

    const DownloadImage = () => {
        var node = document.getElementById('invoiceBarcode');

        htmlToImage.toPng(node)
            .then(function (dataUrl) {
                var link = document.createElement('a');
                link.download = TotalAmountAndCustomerPDFInfo.InvoiceID !== undefined ? (TotalAmountAndCustomerPDFInfo.InvoiceID + "_" + moment(TotalAmountAndCustomerPDFInfo.createdAt).local().format("DDMMYYYY")) : "Invoice_Barcode.png";
                link.href = dataUrl;
                link.click();
            })
            .catch(function (error) {
                console.error('oops, something went wrong!', error);
            });
    }

    const Failure = (err) => {
        FailureAlert(err);
    };

    const emailDataEditSuccess = (data) => {
        Alert.success(data, {
            position: 'bottom-right',
            effect: 'slide',
            html: false
        });
    };

    const OnBreakupChange = (e) => {
        setWithBreakup(e.target.checked);
    };

    const OnInsuranceChange = (e) => {
        setInsurance(e.target.checked);
    };

    const GetAccountType = (type) => {
        switch (type) {
            case 1: return "Current";
            case 2: return "Savings";
            case 3: return "CC";
            case 4: return "OD";
            default: return "Current";
        };
    };

    return (
        <div>
            <Header></Header>
            <div className="container-fluid InvoiceTheme sidemenu-show">
                <div className="row">
                    <div className="offset-md-1 offset-1 col-md-5 col-12">
                        <div style={{ width: "80%" }}>
                            <Select styles={{ borderRadius: "20px" }} isClearable={true} isSearchable={true} placeholder="Select Invoice"
                                options={InvoicesInfo}
                                value={SelectedInvoiceDropDownInfo.value !== null ? SelectedInvoiceDropDownInfo : ''}
                                onChange={setInvoiceIDCriteria}></Select>
                        </div>
                    </div>
                    {SelectedInvoicePDFInfo > 0 && (<div style={{ display: "flex", alignItems: "center", justifyContent: "space-around" }} className="col-md-3 col-10">
                        <span style={{ paddingLeft: "1.5rem", verticalAlign: "text-bottom", paddingRight: "10px" }}>Breakup</span>
                        <input checked={WithBreakup} onChange={OnBreakupChange} name="WithBreakup" type="checkbox"></input>
                        <span style={{ paddingLeft: "1.5rem", verticalAlign: "text-bottom", paddingRight: "10px" }}>insurance</span>
                        <input checked={Insurance} onChange={OnInsuranceChange} name="Insurance" type="checkbox"></input>

                    </div>)}
                    {SelectedInvoicePDFInfo > 0 && (<div style={{ border: "1px solid #ccc", borderRadius: "6px", display: "flex", justifyContent: "space-around" }} className="col-md-2 col-3">
                        {TotalAmountAndCustomerPDFInfo && (<div title="Download Invoice Barcode" style={{ fontSize: "1.3rem", cursor: "pointer", color: "green" }}
                            onClick={DownloadImage}><FontAwesomeIcon icon={faDownload} />
                        </div>)}
                        {parseInt(process.env.REACT_APP_EMAIL_REQUIRED) === 1 && (<div style={{ fontSize: "1.5rem", color: "#25bbf7" }} className="hover-style" onClick={SendEmail}>
                            <FontAwesomeIcon title="Send Email" icon={faEnvelope}></FontAwesomeIcon>
                        </div>)}
                        <div style={{ fontSize: "1.4rem", color: "red" }} className="hover-style" onClick={printPDF}>
                            <FontAwesomeIcon title="Generate PDF" icon={faFilePdf}></FontAwesomeIcon>
                        </div>
                    </div>)}
                </div>
                <hr></hr>
                {(SelectedInvoicePDFInfo > 0 && TotalAmountAndCustomerPDFInfo) && (<div className=""><div className="row" id="page">

                    <div className="col-md-12">
                        <div className="WaterMarkStyle" style={{ backgroundImage: (OrgData.Organization && OrgData.Organization.length > 0 && OrgData.Organization[0].LogoApproval && OrgData.Organization[0].LogoApproval === 1) ? "url('" + WaterMark + "')" : "none" }}>
                            <div className="row GenerateQuoteTitleStyle">
                                <div className="col-md-6 col-12 responsive-align">
                                    <div style={{ fontSize: "40px", color: "#005582", paddingLeft: "6px", fontWeight: "600" }}>INVOICE</div>
                                    <div id="invoiceBarcode">
                                        <Barcode width={1} height={35} displayValue={true}
                                            value={TotalAmountAndCustomerPDFInfo.InvoiceID + "_" + moment(TotalAmountAndCustomerPDFInfo.createdAt).local().format("DDMMYYYY")}></Barcode>
                                    </div>
                                </div>
                                <div style={{
                                    display: "flex"
                                }} className={`${((ProductsPDFInfo.Customer && ProductsPDFInfo.Customer.length > 0 && ProductsPDFInfo.Customer[0].IBAApproval === 1) ||
                                    (ProductsPDFInfo.Customer !== undefined && ProductsPDFInfo.Customer.length === 0 &&
                                        ProductsPDFInfo.InstantCustomerIBAApproved === 1)) ? "col-md-6" : "offset-md-2 col-md-4"} col-12 align-right`}>

                                    {((ProductsPDFInfo.Customer && ProductsPDFInfo.Customer.length > 0 && ProductsPDFInfo.Customer[0].IBAApproval === 1) ||
                                        (ProductsPDFInfo.Customer !== undefined && ProductsPDFInfo.Customer.length === 0 &&
                                            ProductsPDFInfo.InstantCustomerIBAApproved === 1)) ? <div style={{ width: "100%", padding: "10px", fontSize: "14px", textAlign: "left", borderRight: "1px solid #ccc" }}>{IBAData.IBAAddress ? IBAData.IBAAddress : ""}</div> : ""}

                                    {(ProductsPDFInfo.Customer !== undefined && ProductsPDFInfo.Customer.length > 0) && (<div className="responsive-align" style={{ width: (ProductsPDFInfo.Customer !== undefined && ProductsPDFInfo.Customer.length > 0 && ProductsPDFInfo.Customer[0].IBAApproval === 1) ? "60%" : "100%" }}><img alt="Logo" className="WaterMarkStyle" style={{ width: "10rem", height: "9rem" }} src={(ProductsPDFInfo.Customer[0].IBAApproval === 0 ? companyLogo : (IBALogo === "" ? companyLogo : IBALogo))}></img></div>)}
                                    {(ProductsPDFInfo.Customer !== undefined && ProductsPDFInfo.Customer.length === 0) && (<div className="responsive-align" style={{ width: (ProductsPDFInfo.Customer !== undefined && ProductsPDFInfo.InstantCustomerIBAApproved === 1) ? "60%" : "100%" }}><img alt="Logo" className="WaterMarkStyle" style={{ width: "9rem", height: "8rem" }} src={ProductsPDFInfo.InstantCustomerIBAApproved === 0 ? companyLogo : (IBALogo === "" ? companyLogo : IBALogo)}></img></div>)}
                                </div>
                                <div className="col-md-12" style={{ marginTop: "10px" }}>
                                    <div className="row">
                                        <div className="col-xs-12 col-sm-12 col-md-12" style={{ overflow: "auto", border: "1px solid #ccc", borderRadius: "6px" }}>
                                            <table className="table align-center">
                                                <tbody>
                                                    <tr>
                                                        <td style={{ borderBottom: "1px solid #ccc" }}><b>Invoice No</b> : {TotalAmountAndCustomerPDFInfo.InvoiceID + "_" + moment(TotalAmountAndCustomerPDFInfo.createdAt).local().format("DDMMYYYY")}</td>
                                                        <td colSpan="2" style={{ borderBottom: "1px solid #ccc" }}><b>Date</b> : {moment(TotalAmountAndCustomerPDFInfo.createdAt).local().format("DD.MM.YYYY")}</td>
                                                        <td style={{ borderBottom: "1px solid #ccc" }}><b>Enquiry Date</b> : {(ProductsPDFInfo.Customer && ProductsPDFInfo.Customer.length > 0) ? moment(ProductsPDFInfo.Customer[0].createdAt).local().format("DD.MM.YYYY") : ""}</td>
                                                    </tr>
                                                    <tr>
                                                        <td style={{ borderBottom: "1px solid #ccc" }}><b>Enquiry From</b> :
                                                            {ProductsPDFInfo.Customer && ProductsPDFInfo.Customer.length > 0 ? ProductsPDFInfo.Customer[0].Name : ProductsPDFInfo.InstantCustomerName}
                                                        </td>
                                                        <td colSpan="2" style={{ borderBottom: "1px solid #ccc" }}><b>Phone</b> : {ProductsPDFInfo.Customer && ProductsPDFInfo.Customer.length > 0 ?
                                                            ProductsPDFInfo.Customer[0].PhoneNumber : ProductsPDFInfo.InstantCustomerPhone}</td>
                                                        <td style={{ borderBottom: "1px solid #ccc" }}><b>Email</b> : {ProductsPDFInfo.Customer && ProductsPDFInfo.Customer.length > 0 ?
                                                            ProductsPDFInfo.Customer[0].EmailID : ProductsPDFInfo.InstantCustomerEmail}</td>
                                                    </tr>
                                                    <tr>
                                                        <td colSpan="3" style={{ borderBottom: "1px solid #ccc", textAlign: "left" }}>
                                                            <b style={{ paddingLeft: "6rem" }}>From</b> :
                                                            {ProductsPDFInfo.Customer && ProductsPDFInfo.Customer.length > 0 ?
                                                                ProductsPDFInfo.Customer[0].OriginAddress + " , " + ProductsPDFInfo.Customer[0].OriginCity + " " +
                                                                ProductsPDFInfo.Customer[0].OriginPincode + " , " + ProductsPDFInfo.Customer[0].OriginState + " , " +
                                                                ProductsPDFInfo.Customer[0].OriginCountry : ""}

                                                            {ProductsPDFInfo.Customer && ProductsPDFInfo.Customer.length === 0 ?
                                                                ProductsPDFInfo.InstantCustomerOriginCity + " , " +
                                                                ProductsPDFInfo.InstantCustomerOriginPincode : ""}
                                                        </td>
                                                        <td style={{ borderBottom: "1px solid #ccc" }}>
                                                            <div><b>To</b> :
                                                                {ProductsPDFInfo.Customer && ProductsPDFInfo.Customer.length > 0 ?
                                                                    ProductsPDFInfo.Customer[0].DestinationAddress + " , " + ProductsPDFInfo.Customer[0].DestinationCity + " " +
                                                                    ProductsPDFInfo.Customer[0].DestinationPincode + " , " + ProductsPDFInfo.Customer[0].DestinationState + " , " +
                                                                    ProductsPDFInfo.Customer[0].DestinationCountry : ""}

                                                                {ProductsPDFInfo.Customer && ProductsPDFInfo.Customer.length === 0 ?
                                                                    ProductsPDFInfo.InstantCustomerDestCity + " , " +
                                                                    ProductsPDFInfo.InstantCustomerDestPincode : ""}
                                                            </div>
                                                        </td>
                                                    </tr>
                                                    <tr className="align-center">
                                                        <td><b>Loading Floor</b> :
                                                            {ProductsPDFInfo.Customer && ProductsPDFInfo.Customer.length > 0 ?
                                                                ProductsPDFInfo.Customer[0].OriginFloor : ""}

                                                            {ProductsPDFInfo.Customer && ProductsPDFInfo.Customer.length === 0 ?
                                                                ` ${ProductsPDFInfo.InstantCustomerOriginFloor}` : ""}
                                                        </td>
                                                        <td><b>UnLoading Floor</b> :
                                                            {ProductsPDFInfo.Customer && ProductsPDFInfo.Customer.length > 0 ?
                                                                ProductsPDFInfo.Customer[0].DesinationFloor : ""}
                                                            {ProductsPDFInfo.Customer && ProductsPDFInfo.Customer.length === 0 ?
                                                                ` ${ProductsPDFInfo.InstantCustomerDestFloor}` : ""}

                                                        </td>
                                                        <td><b>Total Items</b> : {GoodsData.length}</td>
                                                        <td><b>JobID</b> : {(ProductsPDFInfo.LorryReciept && ProductsPDFInfo.LorryReciept.length > 0) ? (ProductsPDFInfo.LorryReciept[0].JobID + "-" + moment(ProductsPDFInfo.LorryReciept[0].createdAt).format("DDMMYY")) : ""}</td>

                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="row title" style={{ marginTop: "10px" }}>
                                <div className="col-md-12">
                                    <table className="table table-striped">
                                        <thead>
                                            <tr>
                                                <th style={{ backgroundColor: (companyInfo.ThemeColor ? companyInfo.ThemeColor : "#c4f295"), height: (!WithBreakup ? "35px" : "") }} className="align-center InvoicePDFtitleStyle" >{WithBreakup ? "No." : ""}</th>
                                                <th style={{ backgroundColor: (companyInfo.ThemeColor ? companyInfo.ThemeColor : "#c4f295") }} className="align-left InvoicePDFtitleStyle">{WithBreakup ? "Particular" : ""}</th>
                                                <th style={{ backgroundColor: (companyInfo.ThemeColor ? companyInfo.ThemeColor : "#c4f295") }} className="align-center InvoicePDFtitleStyle">{WithBreakup ? "Amount" : ""}</th>
                                            </tr>
                                        </thead>
                                        {ProductsPDFInfo.PackingCharges !== undefined && (<tbody>
                                            {WithBreakup && (<tr className="align-center">
                                                <td>1</td>
                                                <td className="align-left">Wrapping & Packing Charges</td>
                                                <td className="align-center">{ProductsPDFInfo.PackingCharges.toFixed(2)}</td>
                                            </tr>)}
                                            {WithBreakup && (<tr className="align-center">
                                                <td>2</td>
                                                <td className="align-left">Loading & Stuffing Charges</td>
                                                <td className="align-center">{ProductsPDFInfo.LoadingCharges.toFixed(2)}</td>
                                            </tr>)}
                                            {WithBreakup && (<tr className="align-center">
                                                <td>3</td>
                                                <td className="align-left">Pickup & Delivery Charges</td>
                                                <td className="align-center">{ProductsPDFInfo.PickupCharges.toFixed(2)}</td>
                                            </tr>)}
                                            {WithBreakup && (<tr className="align-center">
                                                <td>4</td>
                                                <td className="align-left">Moving & Transport Charges</td>
                                                <td className="align-center">{ProductsPDFInfo.TransportCharges.toFixed(2)}</td>
                                            </tr>)}
                                            {WithBreakup && (<tr className="align-center">
                                                <td>5</td>
                                                <td className="align-left">Unloading Charges</td>
                                                <td className="align-center">{ProductsPDFInfo.UnloadingCharges.toFixed(2)}</td>
                                            </tr>)}
                                            {WithBreakup && (<tr className="align-center">
                                                <td>6</td>
                                                <td className="align-left">Unpacking & Settling Charges</td>
                                                <td className="align-center">{ProductsPDFInfo.UnpackingCharges.toFixed(2)}</td>
                                            </tr>)}
                                            {WithBreakup && (<tr className="align-center">
                                                <td>7</td>
                                                <td className="align-left">Automobile Transport Charges</td>
                                                <td className="align-center">{ProductsPDFInfo.CarTransportCharges.toFixed(2)}</td>
                                            </tr>)}
                                            {WithBreakup && (<tr className="align-center">
                                                <td>8</td>
                                                <td className="align-left">Other Charges</td>
                                                <td className="align-center">{ProductsPDFInfo.OtherCharges.toFixed(2)}</td>
                                            </tr>)}
                                            <tr>
                                                <td></td>
                                                <td className="align-center"><b>Amount</b></td>
                                                <td className="align-center">
                                                    <b> {ProductsPDFInfo.TotalAmount.toFixed(2)}</b>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td></td>
                                                <td className="align-center"><b>GST ({TotalAmountAndCustomerPDFInfo.CGST > 0 ? (TotalAmountAndCustomerPDFInfo.CGST + TotalAmountAndCustomerPDFInfo.SGST) : TotalAmountAndCustomerPDFInfo.IGST}%)</b></td>
                                                <td className="align-center">
                                                    <b> {((parseFloat(TotalAmountAndCustomerPDFInfo.CGST > 0 ? (TotalAmountAndCustomerPDFInfo.CGST + TotalAmountAndCustomerPDFInfo.SGST) : TotalAmountAndCustomerPDFInfo.IGST) / 100) * ProductsPDFInfo.TotalAmount).toFixed(2)}</b>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td></td>
                                                <td className="align-center"><b>GRAND TOTAL</b></td>
                                                <td className="align-center">
                                                    <b> {((0.05 * ProductsPDFInfo.TotalAmount) + ProductsPDFInfo.TotalAmount).toFixed(2)}</b>
                                                </td>
                                            </tr>
                                        </tbody>)}
                                    </table>
                                </div>

                            </div>
                            <div className="row title align-center">
                                <table className="table">
                                    <tbody>
                                        <tr>
                                            <td style={{ width: "30%" }}><b>Amount (In words) :</b></td>
                                            <td>
                                                <b><span style={{ textTransform: "uppercase" }}> {numberToEnglish(((0.05 * ProductsPDFInfo.TotalAmount) + ProductsPDFInfo.TotalAmount).toFixed(2), "IN")} </span></b>
                                            </td>
                                        </tr>
                                        {/* <tr>
                                            <td style={{ width: "30%" }}><b>Remarks  :</b></td>
                                            <td>
                                                <b><span> {ProductsPDFInfo.Remarks} </span></b>
                                            </td>
                                        </tr> */}
                                    </tbody>
                                </table>
                            </div>
                            {(ProductsPDFInfo.Customer && Insurance) && (<div className="row title">
                                <table className="table">
                                    <tbody>
                                        <tr>
                                            <td style={{ width: "15%" }}></td>
                                            <td className="align-center"><b>Insurance Amount</b></td>
                                            <td className="align-center">
                                                <b> {(ProductsPDFInfo.Customer && ProductsPDFInfo.Customer.length > 0) && ProductsPDFInfo.Customer[0].InsuranceAmount}</b>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>)}
                            <div className="row title">
                                <div style={{ borderRight: (PaymentCode && PaymentCode !== "") ? "1px solid #ccc" : "none" }}
                                    className={(PaymentCode && PaymentCode !== "") ? "col-md-8 col-sm-8 col-12" : "col-md-12 col-sm-12 col-12"}>
                                    <div className="row">
                                        <div className="col-md-12">
                                            <h5> BANK ACCOUNT DETAILS</h5>
                                        </div>
                                        <div className="col-md-12" style={{ paddingTop: "10px" }}>
                                            <div className="row">
                                                <div className="col-md-6 col-sm-6">
                                                    <b> Bank Name</b>
                                                </div>
                                                <div className="col-md-6 col-sm-6">
                                                    {(ProductsPDFInfo && ProductsPDFInfo.Customer && ProductsPDFInfo.Customer.length > 0
                                                        && ProductsPDFInfo.Customer[0].IBAApproval === 1) ?
                                                        <h6 style={{ fontWeight: "600" }}>{IBAData.BankName}</h6>
                                                        : <h6 style={{ fontWeight: "600" }}>{companyInfo.BankName}</h6>}
                                                </div>
                                            </div>
                                        </div>

                                        <div className="col-md-12">
                                            <div className="row">
                                                <div className="col-md-6 col-sm-6">
                                                    <b>Account Number</b>
                                                </div>
                                                <div className="col-md-6 col-sm-6">
                                                    {(ProductsPDFInfo && ProductsPDFInfo.Customer && ProductsPDFInfo.Customer.length > 0
                                                        && ProductsPDFInfo.Customer[0].IBAApproval === 1) ?
                                                        <h6 style={{ fontWeight: "600" }}>{IBAData.AccountNumber}</h6>
                                                        : <h6 style={{ fontWeight: "600" }}>{companyInfo.AccountNumber}</h6>}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-12">
                                            <div className="row">
                                                <div className="col-md-6 col-sm-6">
                                                    <b>Branch</b>
                                                </div>
                                                <div className="col-md-6 col-sm-6">
                                                    {(ProductsPDFInfo && ProductsPDFInfo.Customer && ProductsPDFInfo.Customer.length > 0
                                                        && ProductsPDFInfo.Customer[0].IBAApproval === 1) ?
                                                        <h6 style={{ fontWeight: "600" }}>{IBAData.Branch}</h6>
                                                        : <h6 style={{ fontWeight: "600" }}>{companyInfo.Branch}</h6>}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-12">
                                            <div className="row">
                                                <div className="col-md-6 col-sm-6">
                                                    <b>IFSC Code</b>
                                                </div>
                                                <div className="col-md-6 col-sm-6">
                                                    {(ProductsPDFInfo && ProductsPDFInfo.Customer && ProductsPDFInfo.Customer.length > 0
                                                        && ProductsPDFInfo.Customer[0].IBAApproval === 1) ?
                                                        <h6 style={{ fontWeight: "600" }}>{IBAData.IFSCCode}</h6>
                                                        : <h6 style={{ fontWeight: "600" }}>{companyInfo.IFSCCode}</h6>}
                                                </div>
                                            </div>
                                        </div>
                                        {companyInfo.AccountName && (<div className="col-md-12">
                                            <div className="row">
                                                <div className="col-md-6 col-sm-6 col-6">
                                                    Account Name
                                                </div>
                                                <div className="col-md-6 col-sm-6 col-6">
                                                    {(ProductsPDFInfo && ProductsPDFInfo.Customer && ProductsPDFInfo.Customer.length > 0
                                                        && ProductsPDFInfo.Customer[0].IBAApproval === 1) ?
                                                        <h6 style={{ fontWeight: "600" }}>{IBAData.AccountName}</h6>
                                                        : companyInfo.AccountName && (<h6 style={{ fontWeight: "600" }}>{companyInfo.AccountName}</h6>)}
                                                </div>
                                            </div>
                                        </div>)}
                                        {companyInfo.AccountType && (<div className="col-md-12" style={{ paddingBottom: "10px" }}>
                                            <div className="row">
                                                <div className="col-md-6 col-sm-6 col-6">
                                                    Account Type
                                                </div>
                                                <div className="col-md-6 col-sm-6 col-6">
                                                    {(ProductsPDFInfo && ProductsPDFInfo.Customer && ProductsPDFInfo.Customer.length > 0
                                                        && ProductsPDFInfo.Customer[0].IBAApproval === 1) ?
                                                        <h6 style={{ fontWeight: "600" }}>{GetAccountType(IBAData.AccountType)}</h6>
                                                        : companyInfo.AccountType && (<h6 style={{ fontWeight: "600" }}>{GetAccountType(companyInfo.AccountType)}</h6>)}
                                                </div>
                                            </div>
                                        </div>)}
                                        <div className="col-md-12" style={{ borderTop: "1px solid #ccc", paddingTop: "10px" }}>
                                            <div className="row">
                                                <div className="col-md-6 col-sm-6">
                                                    <b>PAN Number</b>
                                                </div>
                                                <div className="col-md-6 col-sm-6">
                                                    {(ProductsPDFInfo && ProductsPDFInfo.Customer && ProductsPDFInfo.Customer.length > 0
                                                        && ProductsPDFInfo.Customer[0].IBAApproval === 1) ?
                                                        <h6 style={{ fontWeight: "600" }}>{IBAData.PANNumber}</h6> :
                                                        <h6 style={{ fontWeight: "600" }}>{OrgData.Organization && OrgData.Organization.length > 0 ? OrgData.Organization[0].PANNumber : ""}</h6>}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-12">
                                            <div className="row">
                                                <div className="col-md-6 col-sm-6">
                                                    <b>GST Number</b>
                                                </div>
                                                <div className="col-md-6 col-sm-6">
                                                    {(ProductsPDFInfo && ProductsPDFInfo.Customer && ProductsPDFInfo.Customer.length > 0
                                                        && ProductsPDFInfo.Customer[0].IBAApproval === 1) ?
                                                        <h6 style={{ fontWeight: "600" }}>{IBAData.GSTNumber}</h6>
                                                        : <h6 style={{ fontWeight: "600" }}>{OrgData.Organization && OrgData.Organization.length > 0 ? OrgData.Organization[0].GSTNumber : ""}</h6>}
                                                </div>
                                            </div>
                                        </div>
                                        {ProductsPDFInfo.Customer && ProductsPDFInfo.Customer.length > 0 && ProductsPDFInfo.Customer[0].IBAApproval === 1 && (<div className="col-md-12">
                                            <div className="row">
                                                <div className="col-md-6 col-sm-6">
                                                    <b>Issued By</b>
                                                </div>
                                                <div className="col-md-6 col-sm-6">
                                                    <h6>{OrgData.Organization && OrgData.Organization.length > 0 ? "MFI " + OrgData.Organization[0].City + " [" + OrgData.Organization[0].Name + "]" : ""}</h6>
                                                </div>
                                            </div>
                                        </div>)}
                                        {ProductsPDFInfo.Customer && ProductsPDFInfo.Customer.length > 0 && ProductsPDFInfo.Customer[0].IBAApproval === 1 && (<div className="col-md-12">
                                            <div className="row" style={{ color: "red", fontSize: "18px" }}>
                                                <div className="col-md-6 col-sm-6">
                                                    <b>IBA No.</b>
                                                </div>
                                                <div className="col-md-6 col-sm-6">
                                                    <span style={{ border: "1px solid red", padding: "2px 20px", borderRadius: "6px" }}>{IBAData.IBANumber ? IBAData.IBANumber : ""}</span>
                                                </div>
                                            </div>
                                        </div>)}
                                    </div>
                                </div>
                                {PaymentCode && PaymentCode !== "" && (<div style={{ textAlign: "center", margin: "auto" }} className="col-md-4 col-sm-4 col-12">
                                    <div>Payment QR</div>
                                    <div>
                                        <img width="150" height="150" alt="Payment Code" src={PaymentCode}></img>
                                    </div>
                                    <div>Scan the code for payment</div>
                                </div>)}

                                {ProductsPDFInfo.Customer && ProductsPDFInfo.Customer.length > 0 && companyInfo.InvoiceTerms !== null && companyInfo.InvoiceTerms !== undefined && (<div className="col-md-12" style={{ paddingTop: "10px" }}>
                                    <div className="row">
                                        <div className="col-md-12 col-sm-12">
                                            <hr></hr>
                                            <div>
                                                <h5> Terms and Conditions</h5>
                                            </div>
                                            <ol>
                                                {ProductsPDFInfo.Customer[0].IBAApproval === 0 && companyInfo.InvoiceTerms.split('|').map((terms, index) => (
                                                    <li key={index} dangerouslySetInnerHTML={{ __html: terms }}>
                                                    </li>
                                                ))}
                                                {ProductsPDFInfo.Customer[0].IBAApproval === 1 && IBAData.IBATerms && IBAData.IBATerms.split('|').map((terms, index) => (
                                                    <li key={index} dangerouslySetInnerHTML={{ __html: terms }}>
                                                    </li>
                                                ))}

                                            </ol>
                                        </div>

                                    </div>
                                </div>)}
                            </div>
                            <div className="row">
                                <div className="col-md-12 align-left" style={{ paddingLeft: "2rem", paddingBottom: "2rem" }}>
                                    <div>Thanking you for your valuable order.</div>
                                    <div style={{ paddingTop: "10px" }}>With Regards, </div>
                                    <div className='row'>
                                        <div className="col-md-12 col-12">
                                            {(ProductsPDFInfo && ProductsPDFInfo.Customer && ProductsPDFInfo.Customer.length > 0
                                                && ProductsPDFInfo.Customer[0].IBAApproval === 1) ?
                                                <div><b>For {IBAData.AccountName}</b>
                                                    <div>
                                                        <div className="title" style={{ margin: "5px 0 0 0", width: "40%", border: "none" }}>
                                                            <div style={{ paddingBottom: "50px" }}>
                                                            </div>
                                                            <h6 className="align-right"><b>Authorized Signatory</b></h6>
                                                        </div></div></div> :
                                                <div><b><div>{OrgData.Organization && OrgData.Organization.length > 0 ? OrgData.Organization[0].Name : ""}</div></b>
                                                    <b><div style={{ width: "200px" }}>{companyInfo.BillingAddress}</div></b></div>}
                                        </div>
                                        <div className="col-md-12 col-12 text-center" style={{ fontSize: "13px" }}>
                                            <b>**</b> This is computer generated Document. No signature required <b>**</b>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div></div>)}
            </div>
        </div>
    );
};

export default GenerateInvoice;